import { Component } from '@angular/core';
import { ListOrdersComponent } from 'components/sale/orders/list-orders.component';
import { CredentialType } from 'enums/CredentialType';
import { OrderModel } from 'models/generated/Entities.GormCrm.Order';
import { Layout } from 'modules/layout';
import { TeamPipe } from 'pipes/team.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { UserPipe } from 'pipes/user.pipe';
import { UserService } from 'services/user.service';
import { ComponentUrl } from 'services/navigation.service';
import { CredentialRequired, CredentialService } from 'services/credential.service';

@Component({
	selector: 'list-unapproved-sales',
	templateUrl: './list-unapproved-sales.component.html',
	imports: [Layout, ListOrdersComponent, TranslatePipe]
})
@ComponentUrl('list-unapproved-sales')
@CredentialRequired(CredentialType.ListOrdersForApproval)
export class ListUnapprovedSalesComponent {

	selectedTeamId: string[] | undefined;

	constructor(private readonly team: TeamPipe,
		private readonly user: UserPipe,
		private readonly userService: UserService,
		private readonly credentialService: CredentialService) {

		if (!this.credentialService.hasCredentials(CredentialType.ManageSales)) {
			const currentUser = this.userService.getCurrentUser();
			this.selectedTeamId = currentUser.userTeams.map(ut => ut.teamId!);
		}
	}

	getSalesTeam = (order: OrderModel) => this.team.transform(order.salesTeamId);
	getSellerName = (order: OrderModel) => this.user.transform(order.sellerId, 'name');
	isCompleted = (order: OrderModel) => !!order.approvedDate || order.orderCancellations.length > 0;
}
